

















import {defineComponent} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';

export default defineComponent({
  name: 'Chem115_LabSkills_TaAssessment',
  mixins: [DynamicQuestionMixin()],
});
